// extracted by mini-css-extract-plugin
export var body = "_mj-5";
export var closeButton = "_mj-f";
export var container = "_mj-1";
export var content = "_mj-2";
export var cta = "_mj-c";
export var ctaLabel = "_mj-b";
export var eyebrow = "_mj-3";
export var howTo = "_mj-6";
export var image = "_mj-e";
export var modal = "_mj-0";
export var socialButton = "_mj-d";
export var stepCard = "_mj-8";
export var stepLabel = "_mj-a";
export var stepNumber = "_mj-9";
export var steps = "_mj-7";
export var title = "_mj-4";